import {
  FC,
} from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import AuthLogo from '../components/AuthLogo';
import { UseTranslate } from '../../hooks/Translate';

type Params = {
  userId: string;
};

const RegisterSuccessPage: FC = () => {
  const params = useParams<Params>();

  const navigate = useNavigate();
  const [translate] = UseTranslate();
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isMobile = isIOS || isAndroid;
  console.log(isMobile)
  return (

    <div style={isMobile ? { height: '100vh', display: 'flex', flexDirection: 'column', } : {}}>
      <div className="auth-wrapper" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div className="text-center">
          <AuthLogo />
        </div>
        {
          params.userId && (
            <div className="text-center">
              {translate('cas.registration.successText')}
            </div>
          )
        }
        <Button style={!isMobile ? { marginTop: 30 } : { marginBottom: 100 }} variant="primary" className="w-100" onClick={() => navigate('/register')}>
          {translate('cas.registration.successButton')}
        </Button>
      </div>
    </div>
  );
};

export default RegisterSuccessPage;
